'use strict';
import {IONIC_VIEW_ENTER, IONIC_VIEW_BEFORE_LEAVE} from '../../config/constants/view-events';

module.exports = [
  '$provide',
  ViewHeaderButtonsServiceDecorator];

function ViewHeaderButtonsServiceDecorator($provide) {
  //$provide.decorator('ViewHeaderButtonsService', ['$delegate', '$translate', decorateService]);

  function decorateService($delegate, $translate) {
    $delegate.bindActionToScope = bindActionToView;
    $delegate.bindContextToScope = bindContextToView;
    $delegate.bindToScope = bindToView;

    function bindActionToView(scope, label, icon, action) {
      console.log('ViewHeaderButtonsService.bindActionToView', label ? label : icon);
      var unregister;
      scope.$on(IONIC_VIEW_ENTER, tryCatch(function(){
        console.log('ViewHeaderButtonsService.bindActionToView.$on', label ? label : icon);
        unregister = $delegate.registerAction(
          label ? $translate.instant(label) : null, icon, action);
      }));
      scope.$on(IONIC_VIEW_BEFORE_LEAVE, tryCatch(function(){
        console.log('ViewHeaderButtonsService.bindActionToView.$off', label ? label : icon);
        unregister && unregister();
        unregister = null;
      }));
    }

    function bindContextToView(scope, label, icon, action) {
      console.log('ViewHeaderButtonsService.bindContextToView', label ? label : icon);
      var unregister;
      scope.$on(IONIC_VIEW_ENTER, tryCatch(function(){
        console.log('ViewHeaderButtonsService.bindContextToView.$on', label ? label : icon);
        unregister = $delegate.registerContext(
        label ? $translate.instant(label) : null, icon, action);
      }));
      scope.$on(IONIC_VIEW_BEFORE_LEAVE, tryCatch(function(){
        console.log('ViewHeaderButtonsService.bindContextToView.$off', label ? label : icon);
        unregister && unregister();
        unregister = null;
      }));
    }

    function bindToView(scope, map) {
      console.log('ViewHeaderButtonsService.bindToView', map);
      if (map.action) {
        bindActionToView(scope, map.action.label, map.action.icon, map.action.action);
      }

      if (map.context) {
        bindContextToView(scope, map.context.label, map.context.icon, map.context.action);
      }
    }

    return $delegate;
  }

  function tryCatch(fn) {
    return function () {
      try {
        fn();
      } catch (error) {
        console.error(error);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/dynamic-header-buttons/ViewHeaderButtonsServiceDecorator.js